import {useCallback, useEffect, useLayoutEffect} from "react";
import {useRecoilState, useSetRecoilState} from "recoil";
import {useNotification} from "./useNotification";
import {ConstructorModel} from "../data";
import {useGetConstructorModels} from "../data/queries";
import {
    stateIsExternalLoad,
    stateLoading,
    stateSelectedAccessories,
    stateSelectedComplectations,
    stateSelectedModel,
    stateSelectedSize
} from '../data/atoms'

export const useBuilderModels = () => {
    const setLoading = useSetRecoilState(stateLoading);
    const [isExternalLoad, setIsExternalLoad] = useRecoilState(stateIsExternalLoad);

    const {showError} = useNotification();
    const [modelActive, setModelActive] = useRecoilState(stateSelectedModel);
    const reset = useResetOnModelChange();

    const {data, isFetched, isError, isFetching} = useGetConstructorModels();

    const changeActiveModel = useCallback((modelId: ConstructorModel['id']) => {
        setIsExternalLoad(false);
        reset();

        const model = data?.find((el) => el.id === modelId) || null;

        setModelActive(model);
    }, [data, reset, setIsExternalLoad, setModelActive])


    /**
     * Set first loaded model as active
     */
    useLayoutEffect(() => {
        if (!isExternalLoad && isFetched && data && data.length > 0 && !modelActive) {
            setModelActive(data[0]);
        }
    }, [data, isExternalLoad, isFetched, modelActive, setModelActive]);

    /**
     * Check for errors
     * and data existed at least
     */
    useEffect(() => {
        if (isError || (isFetched && !data?.length)) {
            showError(
                'Ошибка загрузки моделей сумок',
                'Попробуйте обновить страницу или обратитесь к администратору магазина'
            );
        }
    }, [data?.length, isError, showError, isFetched]);


    useLayoutEffect(() => {
        setLoading(prevState => ({...prevState, models: isFetching}));
    }, [isFetching, setLoading])


    return {
        models: data || [],
        modelActive,
        changeActiveModel,
    }
};


/**
 * This hook is used to clean selected data during Active model changing
 */
const useResetOnModelChange = () => {
    const setSize = useSetRecoilState(stateSelectedSize);
    const setComplectations = useSetRecoilState(stateSelectedComplectations);
    const setAccessories = useSetRecoilState(stateSelectedAccessories);

    return () => {
        setSize(null);
        setComplectations({});
        setAccessories({});
    };
};
